/**
 * Website forms: opt-in for automated intake reminders (checked by default).
 */

import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation, useCurrentLanguage } from '../hooks/useTranslation'

export default function MarketingConsentField({ checked, onChange, id = 'marketing-consent' }) {
  const t = useTranslation()
  const language = useCurrentLanguage()
  const prefix = language === 'pt' ? '/pt' : language === 'en' ? '/en' : ''

  return (
    <div className="text-sm text-gray-600">
      <label htmlFor={id} className="flex items-start gap-2.5 cursor-pointer">
        <input
          id={id}
          name="marketing_consent"
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="mt-0.5 shrink-0 rounded border-gray-300 text-green-600 focus:ring-green-600"
        />
        <span>{t('common.marketingConsent.label')}</span>
      </label>
      <p className="mt-2 pl-[1.625rem] text-xs text-gray-500 leading-relaxed">
        {t('common.marketingConsent.disclosure')}{' '}
        <Link
          to={`${prefix}/sms-privacy-policy`}
          className="text-primary-darkGreen underline hover:no-underline"
        >
          {t('common.marketingConsent.smsPrivacyLink')}
        </Link>
        {' · '}
        <Link
          to={`${prefix}/sms-terms`}
          className="text-primary-darkGreen underline hover:no-underline"
        >
          {t('common.marketingConsent.smsTermsLink')}
        </Link>
      </p>
    </div>
  )
}
